// Dependecies
import React, { useRef } from 'react'
import { NavLink, Link} from 'react-router-dom'
import { HiOutlineMenu } from "react-icons/hi";
import { IoIosClose } from "react-icons/io";
import HomeLogo from 'images/logo/home-logo.png'

function Header() {

  const ref = useRef();

  const navLinks = [
    { path: 'online-quotes', name: 'Online Quotes' },
    { path: 'group-health', name: 'Group Health' },
    { path: 'our-carriers', name: 'Our Carriers' },
    { path: 'faqs', name: 'FAQs' },
    { path: 'about-us', name: 'About Us' },
    {
      path: 'contact-us',
      name: 'Contact Us'
      // <div className="dropdown dropdown-hover">
      //   {/* <div tabIndex={0} role="button" className="btn btn-link btn-sm p-0 text-[16px] text-[#111111] no-underline hover:no-underline no-animation">Contact Us</div> */}
      //   <div tabIndex={0} role="button">Contact Us</div>
      //   <ul tabIndex={0} className="dropdown-content z-[1] menu p-2 shadow border border-[rgba(0,0,0,0.07)] bg-[#FEFEFE] rounded-box w-48">
      //     {/* <li className='text-primary hover:bg-slate-200 rounded-box py-2 px-4' onClick={() => navigate('/agent')}>Join Us</li> */}
      //     <button className='text-primary btn btn-link hover:bg-slate-200 text-left no-animation hover:no-underline no-underline' onClick={naviagetToJoinUs}>Become An Agent</button>
      //   </ul>
      // </div>
    },
    { path: 'blog', name: 'Blog' },
    { path: 'agent', name: 'Become An Agent' },
  ];

  const pageList = navLinks.map((link) => (
    <NavLink to={link.path} key={link.name}
      onClick={() => {
        if (ref.current.checked) document.getElementById("sidebar-drawer").click();
      }}
    >
      {link.name}
    </NavLink>
  ));



  return (
    <div className='flex items-center px-4 sm:px-8 md:px-2 lg:px-14 xl:px-0 justify-center drawer drawer-end sticky top-0 bg-base-100 shadow z-50 h-24'>
      <div className='layout-width flex justify-between items-center h-full'>

        {/* SideBar Toggle */} {/* Required on top */}
        <input id="sidebar-drawer" type="checkbox" ref={ref} className="drawer-toggle border-5 hidden" />



        {/* DESKTOP */}

        {/* Home Logo */}
        <Link to='/'><img className='w-48 min-w-32' alt='IE-logo' src={HomeLogo} /></Link>
        {/* <Link to='/' className='lg:hidden'><img className='w-20 min-w-10 h-auto' alt='Small-IE-logo' src={SmallLogo} /></Link> */}

        {/* Header Links */}
        <div className='topbar-links text-center font-bold text-xs xl:text-base h-full hidden md:flex'>
          {pageList}
          <div className="tooltip tooltip-bottom" data-tip="Call Insurance Enterprise">
            <a href='tel:8883506605' rel='noreferrer'>
              <button className="btn btn-secondary text-base-100">(888) 350-6605</button>
            </a>
          </div>
        </div>



        {/* MOBILE */}


        {/* Burger Menu  */}
        <div className='flex-none md:hidden h-auto pl-8 pr-2 cursor-pointer'>
          <label htmlFor="sidebar-drawer" aria-label="open sidebar" className="btn btn-square btn-ghost">
            <HiOutlineMenu style={{ fontSize: '30px' }} />
          </label>
        </div>

        {/* Sidebar */}
        <div className="drawer-side md:hidden overflow-hidden z-10">
          <label htmlFor="sidebar-drawer" aria-label="close sidebar" className="drawer-overlay"></label>
          {/* Sidebar content down here */}
          <div className="p-4 w-80 min-h-full bg-base-100">
            <label className='btn btn-ghost btn-square my-2' htmlFor="sidebar-drawer" aria-label="close sidebar">
              <IoIosClose style={{ fontSize: '50px' }} />
            </label>
            <div className='sidebar-links menu text-lg'>
              {pageList}
              <a href='tel:8883506605' rel='noreferrer'>
                <button className="btn btn-secondary text-base-100">(888) 350-6605</button>
              </a>
            </div>
          </div>
        </div>

      </div>

    </div>
  )
}

export default Header